<template>
  <div class="cover-img-container">
    <div class="cover-img" v-for="(src, index) in data" :key="index">
      <img v-viewer="src" :src="src | ossStyle(200)" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CoverImg',
  props: {
    data: Array,
  },
};
</script>

<style lang="scss">
.cover-img-container {
  &::after {
    content: '';
    display: table;
    clear: both;
  }

  .cover-img {
    float: left;
    width: 200px;
    height: 244px;
    margin: 0 10px 10px 0;
    transition: border-color 0.5s cubic-bezier(0.645, 0.045, 0.355, 1);
    border: 1px solid #ebeef5;
    border-radius: 4px;

    img {
      display: block;
      max-width: 100%;
      max-height: 100%;
      border-radius: 5px;
    }

    &:hover {
      border-color: #c0c4cc;
    }
  }
}
</style>
